/** @jsx jsx */
import { jsx } from '@emotion/react';

import ErrorBoundaryWithTagging from 'bundles/common/components/ErrorBoundaryWithTagging';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import LevelSetsCards from 'bundles/levelsets/levelsets-v2/components/LevelSetsCards';
import EnterpriseLevelSetsModule from 'bundles/page-config-common/components/enterprise/EnterpriseLevelSetsModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { usePageContext } from 'bundles/page-config-common/contexts/PageContext';
import { useEnterpriseLevelSets } from 'bundles/page-config-common/contexts/enterprise/EnterpriseLevelSetsContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const EnterpriseLevelSetsCardsModuleRenderer = () => {
  const program = useProgram();
  const pageContext = usePageContext();
  const { levelSets, levelSetsLoading, hasError } = useEnterpriseLevelSets();

  const enableEnterpriseHomeRefresh = GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeRefresh');

  if (pageContext?.isEnterprise && program) {
    return (
      <ErrorBoundaryWithTagging componentName="EnterpriseLevelSetsCardsModuleRenderer">
        {enableEnterpriseHomeRefresh ? (
          <HomeSection>
            <EnterpriseLevelSetsModule levelSets={levelSets} levelSetsLoading={levelSetsLoading} hasError={hasError} />
          </HomeSection>
        ) : (
          <LevelSetsCards programId={program.id} />
        )}
      </ErrorBoundaryWithTagging>
    );
  } else {
    return null;
  }
};

export default EnterpriseLevelSetsCardsModuleRenderer;
